import PropTypes from 'prop-types'

const DropDownButton = ({ idCenario, text, onClick }) => {

    // DropDownButton.handleClickOutside = () => {
    //     document.getElementById('myDropdown').classList.toggle("show");
    // };

    return (
        <div className="dropdown">
            {idCenario===0 && <button onClick={onClick} className='ripple'> {text} </button>}
            {idCenario===1 && <button1 onClick={onClick} className='ripple1'> {text} </button1>}
            {idCenario===2 && <button2 onClick={onClick} className='ripple2'> {text} </button2>}
            <div id={'myDropdown'} className="dropdown-content">
                <a id={'dijkstra'} href='#'>Dijkstra</a>
                <a id={'astar'} href="#">A* Search</a>
                <a id={'bfs'} href="#">Breadth-First Search</a>
                <a id={'dfs'} href="#">Depth-First Search</a>
                <a id={'bellmanFord'} href="#">Bellman-Ford</a>
                <a id={'floydWarshall'} href="#">Floyd-Warshall</a>
            </div>
        </div>

    )
}

DropDownButton.defaultProps = {
    color: 'white'
}

DropDownButton.propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    onClick: PropTypes.func,
}

export default DropDownButton